<template>

  <div class="mine">

    <van-pull-refresh v-model="isLoading" :pulling-text="$t('msg.下拉即可刷新')" :loosing-text="$t('msg.释放即可刷新')" :loading-text="$t('msg.加载中')" @refresh="onRefresh">
      <div class="mine-top">
        <van-nav-bar class="nav-bar">
          <template #left>
            <img @click="$router.push('/')" src="img/home.png" style="width: 30px; ">
          </template>
          <template #right>
            <img @click="service" style="width: 30px; "
                 src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAABXJJREFUaEPVmb2yDUEUhZdcFV7AzxMgUSVCgBClxHgCPIBCkeMF/IQkSAkQCxCQ4gnwAIr6bs06tc8+09M9c2YCXXXr3nvOme691l577e4+u/Sfj10LxH9E0p5u3pOSvnc/vPR+7vXmALBX0jlJBHteEv8PjXeSXkp6FYBNxrUNAAK9Jul6Q9ClAJ9Ieijp01QEUwFckXR/IPDPkn6loE4MBPlA0p2eZ6q4xgKA9cedVOLkvyXBpuVRWpj6QGoQcDh9iFq5MDYbYwAQ/FtJBOFB4LDHT2a8xh5AbkuKmWEOQEBE02gF0Bc8RQiTfYEflHQgAS3pnBpCjnFc7TJaBdEK4GNi/kbHuhcA4OVOHjBbciJAwC6Fi2Q8yCqv234h5VSLnFoAIA/cxiOyQ6Cwl+2zr4hjf2AuAqZwLZcMArCAGJRmDQBsonsPFkS3DEDxt9l+2vk7Hl8aBAlYpGeJUfxklEAzCDKFxIqjBuCbJPTMoIsCiIETEQSDwFlkbBHzDAQgG9gms/zONXFoqOENAcjseyLXAw4Em82O0UMj2SNjOFHUPXPanSDIZG1MMQQA6ZhxT2Lm0TjBx0IcynTtPWSECQACopBSlG4xCyUAyAb5eDABLNySBPO8P1YyGQRBModJMAhkdLTLrLOQXW81VwkAwcK2tY8ukQ6DySfvXbqsMjckIBWcxoN56dAuasdgUM0SQpfsMBlMhpT4P7pQTRal93+mPhHZJSsQ5XowaczlrQpyLmaACfB1a58P0tpfzCQdGwOO5qwSLFnNUoKsaLcOGnKJaWdECZFSEOMM6JyBxbEAr83Bvi3Sc7lJRqdx/XldYrELYbtIbNVMI4A8GROhPbf3QT9u0BMkQBDzuo54DeZZI84fbTQSh/OhhhXgCMAPUVT2dhDbeWonrSEMSJOC5HdsiDzjNWIWbCLZ8aIEd2ReA+B0svMEfcsgSNLMsyzC/wZP/+C1aMExC/uCZMkMqvDWhbVHA3D1IyUmy8PB8tuHlT6QBI6L9M3hNWhk0ZEcfAQ7CQBMwlL0frKBW3mfFINGIrDH5719rmVuI7Au43ljOAuA2OR+dHsZB7tNg/ubnJHgkU+ccxIAUm8JudGwVrG91+guvG8TsUPR8Hzq8yOjAeQidoeeoydkHLZxmhQSdBeO9joagC2OQsIhSPNcm7kMwGtBDgP7ZkSyLN+VK0Yb9QRIhk4XOzMT8Rpenn18omI2HosA2HfF2w+yYxljKL2dOHderwDjdEoaDVa3NACvg0EAyjtSx7N2wMnbaVDzEAz4sgr0nA3QpW2zdhSdkhVnwM/aJFiT2qM5btReayA+bHhyCm3o8L4tgFxn3oJvnEVaAeQT2uA5tRL9bkn7JX1Nn4sbuGjRdh4ktdE4WwGwVmxgPruOPVaelnRX0k1JbxIAs5xrzGfzXuseAyDuWbK9ORZ0TJBfOtcwy8ck8XOxC/5eCj7uPqlDH27izYg3emuPjgWAhVEPPm72nY8vSXpekNEHSccl/Qnv+5xAgATsrUO8jy1ecI0F4HXjDULf9d/ZLtAz3e9nkh5Jet0DjAOKbz3ivide4eQt+GqaqQCYgB0pQAiAxjJlECSOg/RiPcWbv8FbkG0AEDBp5pwLc1NsFb1H1n1Z7DNw9Zp9WwBTWC89g0x8X0RWYj0U11kKgL8AZGEcZe0uJ0VDoGzcfJXD6Y0MNJ0tlgCQN4G231gn8WtZNyd/XRXPwNUMLwHADgXrdFf2UmwG+Tse8B0cHdbn5bGNce1Wooq28QP5ZJW/4WEaZOJvNLe5nl8EQOwRBOdvWPwV6lxX8jt8LiEhCpjA4/fAVTtszO7Gx5YA4EV8qUV/mJX1iGJJAFNJHfXcP/mqiEDZsEJxAAAAAElFTkSuQmCC">
          </template>
        </van-nav-bar>

        <div class="profile-avatar">
          <div class="van-image van-image--round"
               style="width: 4.2rem; height: 4.2rem; background-color: rgb(255, 255, 255);"><img
              src="img/head.png" class="van-image__img" style="object-fit: cover;"></div>
          <div class="mine-card">
            <div class="user-info">
              <div style="display: flex; align-items: center; column-gap: 12px;">
                <p>{{ userInfo.username }}</p>
                <span>
                  <img src="img/vip.png" alt="">
                  <span style="font-weight: bold;">{{ userInfo.level_name }}</span>
                </span>
              </div>
              <div style="color: rgb(255, 255, 255); padding: 4px 0px;">
                {{ $t("邀请代码") }}:
                <span style="font-weight: bold; display: inline;">{{this.userInfo.invite_code}}</span>
                <img class="van-icon__image" style="width: 1em;margin-left: 5px"  @click="copyText(userInfo.invite_code)"  src="img/copy.svg">
              </div>
              <div style="color: rgb(255, 255, 255); padding: 4px 0px;">
                {{ $t("text.credit_score") }}:
                <span style="font-weight: bold; display: inline;">{{this.userInfo.credit_score}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="center">
        <div class="integral">
          <div @click="doPay()"><i class="van-badge__wrapper van-icon" style="color: rgb(0, 0, 0); font-size: 26px;">
            <img class="van-icon__image" src="data:image/png;base64,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"></i>
            <span>{{ $t("mine.recharge") }}</span>
          </div>
          <div @click="doWithdrawal()"><i class="van-badge__wrapper van-icon" style="color: rgb(0, 0, 0); font-size: 26px;"><img
              class="van-icon__image"
              src="data:image/png;base64,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"></i>
            <span>{{ $t("mine.withdraw") }}</span>
          </div>
        </div>
        <div class="mineJf animate__animated animate__flipInX">
          <div style="text-align: left; padding-bottom: 0.8rem;">
            <div>{{ $t("mine.balance") }}</div>
            <div style="font-size: 1.2rem; font-weight: bold; margin-top: 0.5rem;">{{ $store.getters.getBaseInfo.currency }}
              {{ userInfo.money*1 }}
              <i class="van-badge__wrapper van-icon" @click="onRefresh">
                <img class="van-icon__image" src="img/reload.svg">
              </i>
            </div>
          </div>
          <div style="display: flex; justify-content: space-between;">
            <div style="text-align: left;">
              <div>{{ $t("总收入") }}</div>
              <div style="font-size: 1.2rem; font-weight: bold; margin-top: 0.5rem;">{{ $store.getters.getBaseInfo.currency }} {{ userInfo.total_revenue }}</div>
            </div>
            <div style="text-align: right;">
              <div>{{ $t("冻结金额") }}</div>
              <div style="font-size: 1.2rem; font-weight: bold; margin-top: 0.5rem;">{{ $store.getters.getBaseInfo.currency }} {{ userInfo.freeze_money*1 }}</div>
            </div>
          </div>
        </div>
        <div class="list animate__animated animate__fadeIn">
          <div @click="doWithdrawal()">
            <i class="van-badge__wrapper van-icon" style="color: rgb(134, 134, 134); font-size: 26px;">
              <img class="van-icon__image" src="data:image/png;base64,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"></i>
              <span>{{ $t("mine.withdraw") }}</span>
          </div>
          <div  @click="$router.push({path:'/Setbank'});">
            <i class="van-badge__wrapper van-icon" style="color: rgb(134, 134, 134); font-size: 26px;"><img
              class="van-icon__image"
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAApCAYAAABZa1t7AAAACXBIWXMAAAsTAAALEwEAmpwYAAADdUlEQVRYhc3YW4hVVRgH8N/eHg2ht8yMiojo8jZdsJCSym5QyRAMYRCBIQTVlNVD1ENC2Y1uONiDdJGByIiKLCroRj0JY2FJPolZdBEcSrtNqc05Pay156yzPbPPzGnmNH9YnP+3v4+1/2ddvvWtnT0/MCJXl2lcmWmsztX7cvVaplHP1RVtnvGj+FG/WfvnZV5qWaaR5ep7M43hTGNLpqEm4Fms9f/iTFyNQSyv4QKtonbid8zvkaBxLMD50V6GNTXckAQN4a4eCSpjFbZEvjTHwsT5Qu/1TOBVjEXeyPFP4jyu93omcKwwrTCeo5E45/VezwRyZKkxJzFnhdU6+FdixSy8N8NebJgsoErYiXh7phWVsA+vtXNUTeUh/D0rcprYP5mjasR+welCJqZ19/4XZLF9h+3dCIOf8MYMCZoW5tKuTE+h+XNJ2F+aCb7WaSp7iUO4Cpdj81wSBh/G1nHxzzZOxUU4gvfwZ+HoJOx2oao80uWLs/iObXhca8q5B09qbsBR4SR4pJOwxdjYpaAyVuIdfB3tfjxdijke64W8OVAl7KBQvK0QarZuEmwxYp8LCVW030pi1go7clO0r8VNVcIO40ahHh+viOskLI99FUhHalBzVkbxZuR9U1n8hzuHTBlLcGdijyX8s4Qf0+sEu7Vkv4gR3Kr1vrGtl+miX7gqEqYtF+4YS2MrsB/DvRyx+xK+CmcJuau8qW5BvVfCLtYsn3bhE/ws7MB1SdwXeJepZf6TpiHgxzbPcrye2P0lf2pfX5AqYQvxPpbrnMOyGLMTVwhFZoGncELkT2BP4tuo+WngQXw/FWGLcEkHQWWcK1S9hbDFuDvyA7g/iT1ZOPIIR97DaUdVwn7AY8IIUD1qxUV1O3YkzzcnfEOpj6GEb1JClbAGHoitG/Thmsh/FQ7sAqdorqdRbT6BzeauXJ/w27Rm+ZcSvkabI2+2hC3BdZGP4JXEt0xzeewwyd21LGymrminJbz8aStddzdP1kGudZ0dmAFR8G3Cz074kJDx4RnN+qytsHSULpwhYfuwO/JLsVqoYgeTmHUqUMNHuCPaz+EcYRctmIaQHL8JtdbB+OwrnIHztC52eAh/dBK2FZ8K/ywXSpBukS7sXRgo+b/Bo0K5U4lifV2Ge4VMvKhLUXV8kNjDQgU8hpfxMb6camf/AhqWxqzVsCjQAAAAAElFTkSuQmCC"></i>
            <span>{{ $t("我的银行卡") }}</span>
          </div>
          <div @click="$router.push({path:'/WithdrawRecord'});">
            <i class="van-badge__wrapper van-icon" style="color: rgb(134, 134, 134); font-size: 26px;"><img
              class="van-icon__image"
              src="data:image/png;base64,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"></i>
            <span>{{ $t("提款历史") }}</span>
          </div>
          <div @click="$router.push({path:'/RechargeRecord'});">
            <i class="van-badge__wrapper van-icon" style="color: rgb(134, 134, 134); font-size: 26px;"><img
              class="van-icon__image"
              src="data:image/png;base64,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"></i>
            <span>{{ $t("充值历史") }}</span>
          </div>
          <div @click="service()">
            <i class="van-badge__wrapper van-icon" style="color: rgb(134, 134, 134); font-size: 26px;"><img
              class="van-icon__image" src="img/kefu.svg"></i><span>{{ $t("mine.service") }}</span>
          </div>
          <div @click="$router.push({path:'/Moneylog'});">
            <i class="van-badge__wrapper van-icon" style="color: rgb(134, 134, 134); font-size: 26px;"><img
              class="van-icon__image"
              src="data:image/png;base64,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"></i>
            <span>{{ $t("mine.detail") }}</span>
          </div>
          <div @click="$router.push({path:'/SetLoginPassword'});">
            <i class="van-badge__wrapper van-icon" style="color: rgb(134, 134, 134); font-size: 26px;"><img
              class="van-icon__image"
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAqCAYAAADf/ynVAAAACXBIWXMAAAsTAAALEwEAmpwYAAADMElEQVRYhcXYT4gcRRTH8c/0RFcwgWhITJQEyaKi4B8ieDL496AXDbJ6EUXwoCBKxCB4EVGE+C8qXoQoHsSDiH8RRU8KCrqigieDexDcsBpNDCKu2Tg9HqpbatrZ6Zmuzu4Pmnn1uurVd+p1V1VXZ//MrEyuo6+jL5P/Vy7tTK6r9z+7q9fJ5Du6ehdk8rXdTu9YJp/v6s1m8qPD2gy7yr5Kho6+NZppM+7D9bhkyP2f8DH248smHWQN2uzBHB5aBgq24k58gReb9DNpg5fwFE6doM1d+BZbJuloklS+gjsqvkN4HV/hT0xhGjfgsqjeRfga2/F3m2D3D4F6DE8WQFU9jpuENG4sfFvwPq4dp8NxUnkG9lV8M3h4GahSbwkjNRf5rsEtbYE9WinvxpvjBMfPuBxLke8FdFPBurg1Kn+P58eEKvWLkNpSm3BVKthOg2/gExNCldpncNRurGtQB3Z+ZC/ivQZQhGfxs6h8aV2DOrBtkX0QRxpAlToQ2WvrKteBbYrspWVrjadDkX1aXd91YHkizCh1Rt2sA/stso8lgvwa2Uvojaocz/xnC7uFUyLflZF9prACNNV1kX06HjCYkc8xWwV7EHuNHt5hK0BTrcfTQ/yv4nZCKncL89PInK+QbsMbhBF7tnIzxz8CdI6TC/+SZvu3OG4Z67gwEP3CPxXVm8Gu6u5iT0F8XFiOcuGZy/BXC2BTRdzFCti5eA1nFXVvjsEO4pmEjlO0gHdwT1FeH4/A0cTg0zgpoX3M0okLTYOeh++EfdecsOdqojh7ecozQ/iX7+LCorwNHwnzVHLgFG0WRixWFzsS4yaD/Y4/hvjnhvgmUirYIu6u+Pbix8S4yWDwtsE179MWYrYCtrFS3tBCzFbATsga2wbYCVEbYN2W4gyojYDVb4F1LcRsBWxBWJJKfdNCzMYHd7FyXI17hROd2dHVx1MM1k+IcxiPpKEMKk7lyK+WFVB8cpTFYFut7vSxPbJ7cSrX4RN8KACWqa3+NvFV7aqmDR60HFiDH3BO4dhZXKut5zLhjTq82iSRdmE+wzwuxsvCdqV8CXorcJW7kgV8gCuEHbF/AdqAy28rQCh5AAAAAElFTkSuQmCC"></i>
            <span>{{ $t("setting.password") }}</span>
          </div>
          <div @click="$router.push({path:'/SetPayPassword'});">
            <i class="van-badge__wrapper van-icon" style="color: rgb(134, 134, 134); font-size: 26px;"><img
              class="van-icon__image"
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAwCAYAAACWhbMrAAAACXBIWXMAAAsTAAALEwEAmpwYAAAFWUlEQVRYhb3Yf8yVZRkH8M953gNkgQPatOZqhNpyEmqblZm5TMUNxdjUTSfT0jSWpmaChpaGpaD0hyRaimVbs2IpTdlMmVNnE3U6g0wgsbKwYeDm/In2ntMf1/O85z4Pz/n1vuB3e3buX8/1fM9939f3uu67tvKUdWqaapoyDZlGWznTMGR4l3Lpd+VQbfi0TOPJIcOXZBrrq96peopvFRyiPjZMxRP4OibiGPwZc8didCykjsZf8NmKvruxcLSGR0OqjqV4GB9N2ldhQ1K/Hvdh2p4mdRY24bJS+xqchs+L5SswGxvFrA3tTlJ74Vw8jV9ieqn/OpyYl9/Cobg16Z8gZu1vmI8PjpbUh3ESlmMLbsNnSmNewgn4XsX783Oif0/aPoEVub2lOKQTqVouCV+oaS7INKZlGnvXNPfJND7URRJ+MmT4qkzjrRFpqFVKxfhM4+ohwwszjaxCEtbXNDdmGi/XNF+raT5X01xVxwz8qdeU5vg9FmvfN93wrpjJO3AJzsTeSf/M/ElxV4Yf9DD8Mm4Wy3fKAIRSvIBvYX9chAfwvw5jT6/jwKThv3gFO4QoPoIHxT/eHdiOm/LnYzgCBwvhPVbM2ht1vJe8NF8s0fuBf+VPgatyUs0MjaTjzfeJUBWmFIWyJPTUECGCy8U+6wcfF8LaC7WiUO/TcIp5uCAvTxDC2gkzxb6cjDnC+3piNLFvA97Oy+dgWYdxn8NTOSHa9+5uJ/W0yAwKl/4OLi+N+RIex/i8/gC+tidJESnLUUn9Ohyfl2eLJSv2yOOYNYjxseRT67QCMfwKi0S6UuBZfHFQw2PNPNfgKxjGvrg26duEw7VLTt+kakm9XwP7ikxiKh4SeyoNG+vwKZ1DSRVGvl0X/zKtd8MnheJPT94bxlY0k3HD+Cn2y+sZdorw8lgH2/W08E7SMbUHqXkiqyhjcql+ZP6UcZT2FDpFm6Lv6GK8jF+LiD9adIurI9+u459Jx0d6GN2Ig3BARd9NOA7btDZ/igY2d7E9MoN1PJd0HNyDFLF5N1a0v5T/vlGy2Q/GC8eACXXhKQWOEES7ec0kMdXpmIbWLE/F2Xb15Nfwhw42Dxc5FWyv46/4j5i+SfiySOyqcK44mUzRHssaWiFlCn7R4f07RLws46Sk/GghnquSxvkdDMINQp8ykSEUz176O9cd06H9rKR8d6ENK/DtvDxXiOO2ipe/jyU5iU7YKvbcuKRtHF7VrvgFTtVa+rexuiC1CU9q3Qv8EOdXGFiO32lfvmb+rBDnwNVa+VY/SImuxHtp7FuUlM8Ty1KFbWImtuTPi+LQWejdBwYgdIaIEgV+THtAXitypQLl+4JeKJa03yA/Hrck9Z8Lh9vFwLykvNgobkwGwKVaB9Mmvlt0lEk9LzyswNoBPlLsz36W70Cxbwucj9c7kYIFWoq8P+7pk9Sk/PedrqNi2R7R+hP3iwuUEXRa/zR9/aoQzF5Ygtu1z0AVHtKKcztwcnlAJ1JbS0QW6r3x/4hv4B9dxtyjPaU5VsWVQDdPuQL3JvWl4uQyWvxWzHqBK0UOvwt6ue8ccTwqsEy7nvWL1dpPyXfiR50G96Mps8TSFLgWN/ZJZoLw4HTf3CmyiI7oV+hOwG+S+qXiWrpWPRzh9htEwlfg9l6EBiEFp2u/1JiL9eIus4zZeV9693WDcISeGPTcdwGuSeoz8o/PSdouFwfSVEQvFvrXF0Zz63K1uHL8WV6fKDLKb4p0+sJk7E6RmqRevEdIEcFzs9CdyXnbraUxG8QSbxnU+FiO7Q/j06q15i5xNzUwIcZ+l/BvHCYcYDOeEfvujLEY/T/Bhkpu+cEpQwAAAABJRU5ErkJggg=="></i>
            <span>{{ $t("setting.capital") }}</span>
          </div>
          <div @click="$router.push({path:'/SetLang'});">
            <i class="van-badge__wrapper van-icon" style="color: rgb(134, 134, 134); font-size: 26px;"><img
              class="van-icon__image" src="img/lan.svg"></i><span>{{ $t("setting.lang") }}</span>
          </div>
        </div>
        <a class="btns" @click="loginout">{{ $t("setting.quit") }}</a>
        <div style="height: 60px;"></div>
      </div>
    </van-pull-refresh>
  </div>

</template>

<script>
export default {
  data() {
    return {
      eye: 1,
      userInfo: {},
      menu_top: 40,
      isLoading: false,
    };
  },
  methods: {

    copyText(t) {
      navigator.clipboard.writeText(t);
      this.$toast.success(this.$t("复制成功"));
    },
    //客服
    service() {
      window.location.href = this.$store.getters.getBaseInfo.kefu;
    },
    refresh() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
        if (localStorage.getItem('token')) {
          this.$toast(this.$t("msg.刷新成功！"));
        } else {
          this.$router.push({path: '/Login'})
        }
      }, 500);
    },
    exit() {
      this.$toast(this.$t("msg.请完成任务单后进入"));
    },
    showSetting() {
      if (localStorage.getItem('token')) {
        this.$router.push({path: '/Setting'})
      } else {
        this.$router.push({path: '/Login'})
      }
    },
    toNotice() {
      if (localStorage.getItem('token')) {
        this.$router.push({path: '/Notice'})
      } else {
        this.$router.push({path: '/Login'})
      }
    },

    loginout() {
      localStorage.clear();
      localStorage.setItem('lang', this.lang);
      this.$router.push({path: '/Login'});
    },
    onRefresh() {
      setTimeout(() => {
        this.isLoading = false;
        if (localStorage.getItem('token')) {
          this.getUserInfo();
          this.$toast(this.$t("msg.刷新成功！"));
        } else {
          this.$router.push({path: '/Login'})
        }
      }, 500);
    },
    doLogin() {
      if (localStorage.getItem('token')) {
        this.$router.push({path: '/Infomation'});
      } else {
        this.$router.push({path: '/Login'})
      }
    },
    doPay() {
      if (localStorage.getItem('token')) {
        this.$router.push({path: '/Recharge'});
      } else {
        this.$router.push({path: '/Login'})
      }
    },
    doWithdrawal() {
      if (!this.userInfo.paypassword) {
        this.$router.push("SetPayPassword");
        this.$toast(this.$t("setPayPassword.title"));
        return false;
      }

      this.$http({
        method: 'get',
        url: 'user_get_bank',
      }).then(res => {
        if (res.data.is_bank) {
          this.$router.push("withdraw");
        } else {
          this.$router.push("Setbank");
          this.$toast(this.$t("msg.请设置收款卡!"));
        }
      })
    },
    toService() {
      if (this.$store.getters.getBaseInfo.iskefu == 1) {
        this.$router.push("ServiceOnline");
      } else {
        this.$toast(this.$t("msg.功能已禁用!"));
      }
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
          this.menu_top = 15;
          if (this.userInfo.status !== 1) {
            this.$toast(this.$t("msg.账号下线"));
            localStorage.clear()
            this.$router.push({path: '/Login'})
          }
        } else if (res.code === 401) {
          this.$toast(this.$t(res.msg));
        }
      })
    },
  },
  created() {

    this.getUserInfo();
  }
};
</script>

<style scoped>
p{
  margin: 0;
  padding: 0;
}
.mine {
  width: 100%;
  min-height: 100%;
  background: #f2f2f5
}

.mine .van-share-sheet__description span {
  background: #fff;
  padding: 10px 20px;
  font-size: 14px;
  display: inline-block;
  border-radius: 4px;
  color: #fff;
  margin: 4px 0
}

.mine .mine-top {
  width: 100%;
  height: 430px;
  background: url(/img/usertop.png) no-repeat bottom/160%
}

.mine .mine-top .setting {
  width: 100%;
  text-align: right;
  padding-right: .33333rem
}

.mine .mine-top .profile-avatar {
  width: 100%;
  padding: 0 6%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 1.33333rem
}

.mine .mine-top .profile-avatar .van-image {
  border: 4PX solid #fff
}

.mine .mine-top .profile-avatar .login {
  text-align: left;
  padding-left: 32px
}

.mine .mine-top .profile-avatar .login> {
  padding: .13333rem 0
}

.mine .mine-top .profile-avatar .login p {
  font-size: 1.13333rem;
  color: #fff
}

.mine .mine-top .profile-avatar .login span {
  font-size: .8rem;
  color: hsla(0,0%,100%,.6)
}

.mine .mine-top .profile-avatar .mine-card {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding-left: 1.33333rem;
  flex: 1
}

.mine .mine-top .profile-avatar .mine-card .user-info {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column
}

.mine .mine-top .profile-avatar .mine-card .user-info p {
  font-size: 32px;
  color: #fff;
  padding-bottom: .26667rem
}

.mine .mine-top .profile-avatar .mine-card .user-info img {
  width: 150px;
  margin: 0
}

.mine .mine-top .profile-avatar .mine-card .user-info span {
  color: #ffd849;
  font-size:  28px;
  font-weight: 600;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center
}

.mine .mine-top .profile-avatar .mine-card .user-info span>span {
  position: absolute;
  right: 32px;
  color: #fff;
  font-size:  28px
}

.mine .mine-top .profile-avatar .mine-card .ps {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center
}

.mine .mine-top .profile-avatar .mine-card .ps>span {
  padding-left: .33333rem;
  color: #ffe0f6;
  font-size: .73333rem
}

.mine .mine-top .profile-avatar .mine-card .proess {
  width: 40%;
  height: .26667rem;
  background: #e5d3cb;
  margin: .46667rem 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-radius: .66667rem;
  overflow: hidden
}

.mine .mine-top .profile-avatar .mine-card .proess span {
  background: #fff;
  height: 100%;
  width: 50%
}

.mine .mine-top .profile-avatar .mine-card .jf {
  color: #fff;
  font-size: .8rem
}

.mine .center {
  width: 94%;
  margin: -10% auto 0
}

.mine .center .integral {
  width: 100%;
  background: #fff;
  display: flex;
  justify-content: center;
  padding: 32px 0;
  align-items: center;
  border-radius: .33333rem;
  box-shadow: 0 .13333rem .2rem rgba(0,0,0,.04);
  position: relative;
  z-index: 999
}

.mine .center .integral:before {
  content: "";
  position: absolute;
  width: 3PX;
  height: 1.33333rem;
  border-radius: .66667rem;
  background: #f2f2f5
}

.mine .center .integral>div {
  width: 50%;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center
}

.mine .center .integral>div span {
  margin-left: .66667rem;
  color: #432989;
  font-weight: 600
}

.mine .center .mineJf {
  width: 100%;
  background: #a06098;
  padding:  28px;
  margin-top: .66667rem;
  border-radius: .33333rem;
  box-shadow: 0 .13333rem .2rem rgba(0,0,0,.04);
  color: #fff
}

.mine .center .mineJf .title p {
  color: #fff;
  font-size: .93333rem;
  font-weight: 600
}

.mine .center .mineJf .reload {
  width: 90%;
  margin: 0 auto;
  display: flex;
  padding-top: .33333rem;
  justify-content: space-between;
  align-items: center
}

.mine .center .mineJf .reload h1 {
  color: #fff;
  font-size: 1.33333rem
}

.mine .center .mineJf .reload>div {
  color: #fff;
  font-size:  28px;
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;
  right: 1.33333rem;
  display: flex;
  justify-content: flex-start;
  align-items: center
}

.mine .center .mineJf .reload>div span {
  padding-right: .66667rem
}

.mine .center .mineJf .reload>div i {
  background: #fff;
  color: #9a6cd9;
  border-radius: 50%;
  padding: .33333rem
}

.mine .center .btns {
  display: inline-block;
  width: 90%;
  background: linear-gradient(90deg, #6529c9, #cc2996);
  color: #fff;
  padding:  28px 0;
  border-radius: .33333rem;
  font-size: .93333rem;
  cursor: pointer;
  margin: 1.66667rem 5% 3.33333rem;
  text-align: center;
}

.mine .center .list {
  width: 100%;
  background: #fff;
  padding:  28px 0;
  border-radius: .33333rem;
  box-shadow: 0 .13333rem .2rem rgba(0,0,0,.04);
  margin-top: .8rem;
  display: grid;
  grid-template-columns: repeat(3,1fr)
}

.mine .center .list>div {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 32px 0 32px 6%
}

.mine .center .list>div span {
  color: #432788;
  padding: .53333rem 0;
  font-size: 32px;
}

.mine .center .list>div span>i {
  padding-left: .13333rem
}

.mine .center .list>div>i {
  padding: .2rem
}
</style>
